import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { DialogService } from '../../../../../services'

const KEY = 'confirm-dialog'

@Component({
  selector: 'atyl-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
@Stringable({
  path: 'views/partials/layout/dialogs/confirm-dialog',
  key: KEY,
})
export class ConfirmComponent extends BaseDialogComponent implements OnInit {
  @StringableValues(KEY)
  strings: any
  constructor(
    public dialogRef: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    dialogService: DialogService,
    changeDetectorRef: ChangeDetectorRef,
  ) {
    super(dialogRef, dialogService, changeDetectorRef)
  }

  ngOnInit() {
    console.log(this.data,this.strings);
  }

}
